<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 14a1 1 0 01-.49-.13l-9-5a1 1 0 010-1.74l9-5a1 1 0 011 0l9 5a1 1 0 010 1.74l-9 5A1 1 0 0112 14zM5.06 8L12 11.86 18.94 8 12 4.14z"/><path d="M12 18a1 1 0 01-.49-.13l-9-5a1 1 0 010-1.74l4-2.23 1 1.75L5.06 12 12 15.86 18.94 12l-2.43-1.35 1-1.75 4 2.23a1 1 0 010 1.74l-9 5A1 1 0 0112 18z"/><path d="M12 22a1 1 0 01-.49-.13l-9-5a1 1 0 010-1.74l3.74-2.08 1 1.75L5.06 16 12 19.86 18.94 16l-2.29-1.27 1-1.75 3.87 2.15a1 1 0 010 1.74l-9 5A1 1 0 0112 22z"/></svg>